import React from 'react'
import '../../../../assets/css/screens/customer/dashboard/notifications/Notifications.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import { ArrowLeft} from 'lucide-react';
const notificationsData = [
  {
    id: 1,
    icon: '✓',
    iconClass: 'icon-green',
    title: 'Booking Confirmed',
    message: 'Your AC repair booking with Ali Hassan has been confirmed for March 20.',
    time: '5 min ago',
    isUnread: true,
  },
  {
    id: 2,
    icon: 'ℹ',
    iconClass: 'icon-blue',
    title: 'New Worker Available',
    message: 'A new top-rated electrician is now available in your area.',
    time: '1 hour ago',
    isUnread: true,
  },
  {
    id: 3,
    icon: '⚠',
    iconClass: 'icon-yellow',
    title: 'Job Update',
    message: 'Your deep cleaning service is now in progress.',
    time: '3 hours ago',
    isUnread: false,
  },
  {
    id: 4,
    icon: '✓',
    iconClass: 'icon-green',
    title: 'Service Completed',
    message: 'Kitchen pipe repair by John Smith has been completed. Please rate the service.',
    time: 'Yesterday',
    isUnread: false,
  },
]

const NotificationCard = ({ notification }) => {
    
    
  return (
    
    <div className={`notif-card ${notification.isUnread ? 'unread' : ''}`}>
      <div className={`notif-icon-wrap ${notification.iconClass}`}>
        <span className="notif-icon">{notification.icon}</span>
      </div>
      <div className="notif-content">
        <h6 className="notif-title">{notification.title}</h6>
        <p className="notif-message">{notification.message}</p>
        <p className="notif-time">{notification.time}</p>
      </div>
      {notification.isUnread && <span className="notif-dot"></span>}
    </div>
  )
}

const Notifications = () => {
  return (
    <>
    <AppNavbar/>
    <div className="notif-page">
      <div className="notif-wrapper">

        <div className="notif-header">
          <button className="notif-back-btn" onClick={() => window.history.back()}>
            <ArrowLeft size={20}/>
          </button>
          <h2 className="notif-heading">Notifications</h2>
        </div>

        <div className="notif-list">
          {notificationsData.map((notif) => (
            <NotificationCard key={notif.id} notification={notif} />
          ))}
        </div>

      </div>
    </div>
    </>
  )
}

export default Notifications;